import React, { Component } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      height: '100%',
      width: '100%',
      // maxWidth: '1280px',
      margin: '0 auto',
      color: theme.palette.primary.main,
    },
    fullHeight: {
      height: '100%',
    },
    // wrapper: {
    //   // maxWidth: '1280px',
    //   // margin: '0 auto',
    //   // height: '100%',
    //   width: '100%',
    //   minHeight: 'calc(100% - 150px)',
    //   // background: 'linear-gradient(180deg, rgba(241,243,244,0.42) 0%, rgba(223,227,229,0.42) 100%)',
    //   // borderBottom: '3px ' + primaryColor + ' solid',
    // },
    wrapper: {
      // minHeight: 'calc(100% - 360px - 150px)',
      minHeight: 'calc(100% - 134px)',
      // paddingLeft: theme.spacing(10),
      // paddingRight: theme.spacing(10),
      [theme.breakpoints.down('md')]: {
        // paddingLeft: theme.spacing(8),
        // paddingRight: theme.spacing(8),
        // height: 'auto',
        // minHeight: 'auto',
        // paddingLeft: theme.spacing(4),
        // paddingRight: theme.spacing(4),
      },
      [theme.breakpoints.down('sm')]: {
        // height: 'auto',
        // minHeight: 'auto',
        // paddingLeft: theme.spacing(2),
        // paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.down('xs')]: {
        // paddingLeft: theme.spacing(1),
        // paddingRight: theme.spacing(1),
      },
    },
    content: {
    // paddingLeft: theme.spacing(10),
    // paddingRight: theme.spacing(10),
    },
    titleSmall: {
      fontSize: '2rem',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.2rem',
        textAlign: 'center',
      },
    },
    headerImage: {
      textAlign: 'right',
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
        textAlign: 'center',
      },
    },
  };
};

class Template extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fixedSize: false,
    };
  }
  componentDidMount() {
    if (this.props.resize !== false)
    {
    this._onWindowResize();
    window.addEventListener('resize', this._onWindowResize);
    }
  }
  componendWillUnmount() {
    if (this.props.resize !== false)
    {
    window.removeEventListener('resize', this._onWindowResize);
  }
  }
  _onWindowResize = () => {
    const { classes } = this.props;
    const el = document.querySelector('#root');
    // console.log(el.offsetHeight, window.innerHeight)
    if (el.offsetHeight <= window.innerHeight) {
      el.style.height = window.innerHeight + 'px';
    } else {
      el.style.height = 'auto';
    }
  };
  render() {
    const { classes, title, children, current, headerImage, fixedSizeThreshold, maxWidth } = this.props;
    return (
      <Container
        disableGutters
        className={classes.root}
        fixed={false}
        maxWidth={false}
        style={{
          height: '100%',
          minHeight: '940px',
          maxWidth: maxWidth !== undefined ? maxWidth: '1280px',
        }}
      >
        <Grid className={classes.wrapper} container alignContent="flex-start">
          <Header current={current} headerTitle={title} headerImage={headerImage} headerContent={undefined} />
          <ScrollToTopOnMount />
          <Grid item xs={12} container alignContent="flex-start" className={classes.content}>
            {children}
          </Grid>
        </Grid>
        <Footer />
      </Container>
    );
  }
}

export default withRouter(withStyles(styles)(Template));



// WEBPACK FOOTER //
// ./src/components/Template/Template.jsx